import React from 'react';
import ImModuleStyle from '../styles/im.module.css';

const OrderHistory = ({simObj, setSimObj, getMonth}) => { 
  return (
    <div className={`${ImModuleStyle['order-history']}`}>
      <table>
        <thead>
          <tr>
            <th colSpan="2">Order History</th>
          </tr>
        </thead>
        <tbody>
        {
          simObj.decisionHistory?.sort((a,b)=> b.orderrampvalue - a.orderrampvalue).map((decision,index)=> 
              <tr key={index}>
                <td>{getMonth(decision.statemonth).substring(0,3)} {(decision.stateday)}</td>
                <td>{decision.quantity} units ({decision.ship})</td>
              </tr>
          )         
        }       
        </tbody>
      </table>
    </div>
  )
}

export default OrderHistory